import React, { useState } from 'react';

// Icon Components - Styled like the design
const WhatsAppIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
    </svg>
);

const MailIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
        <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
);

const LocationIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
    </svg>
);

const BoltIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
    </svg>
);

// Social Icons
const FacebookIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
    </svg>
);

const TwitterIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

const LinkedInIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
);

const InstagramIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
);

const ContactUs = ({ preloadedData }) => {
    const [topFormData, setTopFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [bottomFormData, setBottomFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const contactInfo = preloadedData?.contactUs || {
        phone: '+91 9876095163',
        email: 'support@getbentobox.in',
        location: 'Gurgaon, Delhi'
    };

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    const handleTopFormChange = (e) => {
        setTopFormData({ ...topFormData, [e.target.name]: e.target.value });
    };

    const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

    const handleTopFormSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // TODO: Replace this URL with your Google Apps Script Web App URL
        const scriptURL = 'https://script.google.com/macros/s/AKfycbx7oZxu6YRRWi8Kg0X7oHWXy3ZC1q1Di7jfJqDt9Pe1bvIYAWKn2Q9Tdh7ErFe3VEzm/exec';



        try {
            const formData = new FormData();
            formData.append('name', topFormData.name);
            formData.append('email', topFormData.email);
            formData.append('phone', topFormData.phone);
            formData.append('message', topFormData.message);
            // Optional: Add timestamp
            formData.append('timestamp', new Date().toLocaleString());

            await fetch(scriptURL, {
                method: 'POST',
                body: formData,
                mode: 'no-cors' // Use this to handle the Google Apps Script redirect
            });

            // If successful
            setIsSubmitting(false);
            setSubmitSuccess(true);
            setTopFormData({ name: '', email: '', phone: '', message: '' });
            setTimeout(() => setSubmitSuccess(false), 3000);

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsSubmitting(false);
            alert("There was an error submitting the form. Please try again.");
        }
    };

    return (
        <section id="contact" className="!pt-12 md:!pt-16 bg-white">
            {/* First Section - Map + Form */}
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-12 md:pt-12 md:pb-16">
                {/* Header */}
                <div className="text-center mb-10 md:mb-16">
                    <span className="text-orange-500 font-semibold text-sm tracking-widest uppercase">
                        Get In Touch
                    </span>
                    <h1 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
                        We'd Love to Hear <span className="text-orange-500 italic">From You</span>
                    </h1>
                </div>

                {/* Map + Form Card */}
                <div className="bg-white rounded-[2rem] shadow-xl shadow-gray-200/50 border border-gray-100 overflow-hidden flex flex-col lg:flex-row mb-16">
                    {/* Map */}
                    <div className="w-full lg:w-1/2 relative order-1 lg:order-none">
                        <div className="h-56 sm:h-72 md:h-80 lg:h-full w-full bg-gray-100 relative z-0">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224356.91702968857!2d76.82493665!3d28.423015749999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19d582e38859%3A0x2cf5fe8e5c64b1e!2sGurugram%2C%20Haryana!5e0!3m2!1sen!2sin!4v1706715600000!5m2!1sen!2sin"
                                width="100%"
                                height="100%"
                                style={{ border: 0, filter: 'grayscale(15%) contrast(95%)' }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="BentoBox Location"
                                className="w-full h-full object-cover"
                            ></iframe>
                        </div>
                        {/* Overlay gradient to blend map on desktop */}
                        <div className="hidden lg:block absolute top-0 bottom-0 right-0 w-24 bg-gradient-to-l from-white to-transparent pointer-events-none z-10"></div>
                    </div>

                    {/* Contact Form */}
                    <div className="w-full lg:w-1/2 p-6 sm:p-10 md:p-12 lg:p-14 flex flex-col justify-center order-2 lg:order-none bg-white relative z-10">
                        <div className="max-w-lg w-full mx-auto lg:ml-0 lg:mr-auto">
                            <h3 className="text-2xl font-bold text-gray-900 mb-2">Send us a message</h3>
                            <p className="text-gray-500 mb-8">Fill out the form below and we'll get back to you shortly.</p>

                            <form onSubmit={handleTopFormSubmit} className="space-y-5">
                                {/* Name Field */}
                                <div>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Your Name"
                                        value={topFormData.name}
                                        onChange={handleTopFormChange}
                                        className="w-full px-5 py-4 bg-gray-50/50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all text-gray-700 placeholder-gray-400 text-base shadow-sm outline-none"
                                        required
                                    />
                                </div>

                                {/* Email & Phone Row */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                    {/* Email Field */}
                                    <div>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Email Address"
                                            value={topFormData.email}
                                            onChange={handleTopFormChange}
                                            className="w-full px-5 py-4 bg-gray-50/50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all text-gray-700 placeholder-gray-400 text-base shadow-sm outline-none"
                                            required
                                        />
                                    </div>

                                    {/* Phone Number Field */}
                                    <div>
                                        <input
                                            type="tel"
                                            name="phone"
                                            placeholder="Phone Number"
                                            value={topFormData.phone}
                                            onChange={handleTopFormChange}
                                            className="w-full px-5 py-4 bg-gray-50/50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all text-gray-700 placeholder-gray-400 text-base shadow-sm outline-none"
                                        />
                                    </div>
                                </div>

                                {/* Message Field */}
                                <div>
                                    <textarea
                                        name="message"
                                        placeholder="How can we help you?"
                                        value={topFormData.message}
                                        onChange={handleTopFormChange}
                                        rows={4}
                                        className="w-full px-5 py-4 bg-gray-50/50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all text-gray-700 placeholder-gray-400 text-base resize-none shadow-sm outline-none"
                                        required
                                    ></textarea>
                                </div>

                                {/* Submit Button */}
                                <div className="pt-2">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="w-full bg-gradient-to-r from-orange-500 to-orange-400 hover:from-orange-600 hover:to-orange-500 text-white font-semibold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 disabled:opacity-70 disabled:cursor-not-allowed text-base transform hover:-translate-y-0.5"
                                    >
                                        {isSubmitting ? (
                                            <span className="flex items-center justify-center gap-2">
                                                <svg className="animate-spin w-5 h-5" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Sending...
                                            </span>
                                        ) : (
                                            'Send Message'
                                        )}
                                    </button>
                                    {submitSuccess && (
                                        <div className="mt-4 p-3 bg-green-50 text-green-700 rounded-lg flex items-center justify-center gap-2 border border-green-100">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                                            <span className="text-sm font-medium">Message sent successfully!</span>
                                        </div>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Contact Info Cards */}
                <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-12 lg:gap-20 pt-8 border-t border-gray-100">
                    {/* WhatsApp */}
                    <a
                        href={`https://wa.me/${contactInfo.phone.replace(/[^0-9]/g, '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-4 group cursor-pointer hover:transform hover:scale-105 transition-all duration-300"
                    >
                        <div className="w-14 h-14 bg-orange-50 rounded-full flex items-center justify-center group-hover:bg-orange-100 transition-colors">
                            <div className="text-orange-500">
                                <WhatsAppIcon />
                            </div>
                        </div>
                        <div>
                            <p className="font-semibold text-gray-900 text-lg">WhatsApp</p>
                            <p className="text-gray-500 text-sm">{contactInfo.phone}</p>
                        </div>
                    </a>

                    {/* Email */}
                    <a
                        href={`mailto:${contactInfo.email}`}
                        className="flex items-center gap-4 group cursor-pointer hover:transform hover:scale-105 transition-all duration-300"
                    >
                        <div className="w-14 h-14 bg-orange-50 rounded-full flex items-center justify-center group-hover:bg-orange-100 transition-colors">
                            <div className="text-orange-500">
                                <MailIcon />
                            </div>
                        </div>
                        <div>
                            <p className="font-semibold text-gray-900 text-lg">Email</p>
                            <p className="text-gray-500 text-sm">{contactInfo.email}</p>
                        </div>
                    </a>

                    {/* Location */}
                    <div className="flex items-center gap-4 group cursor-pointer hover:transform hover:scale-105 transition-all duration-300">
                        <div className="w-14 h-14 bg-orange-50 rounded-full flex items-center justify-center group-hover:bg-orange-100 transition-colors">
                            <div className="text-orange-500">
                                <LocationIcon />
                            </div>
                        </div>
                        <div>
                            <p className="font-semibold text-gray-900 text-lg">Location</p>
                            <p className="text-gray-500 text-sm">{contactInfo.location}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Second Section - Inquiry Form */}
            <div className="bg-gradient-to-b from-orange-50/50 to-orange-50/30 py-16 md:py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 lg:translate-x-12">
                        {/* Left Side - Info */}
                        <div className="w-full lg:w-1/2 space-y-8 flex flex-col items-center text-center">
                            {/* Header */}
                            <div>
                                <div className="flex items-center justify-center gap-2 text-orange-500 font-semibold text-sm mb-3">
                                    <BoltIcon />
                                    <span>Contact Now</span>
                                </div>
                                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                                    Want To Inquire?
                                </h2>
                                <p className="text-gray-600 leading-relaxed">
                                    Have questions about our subscription plans? We're here to help you get started with authentic home-cooked meals delivered to your doorstep.
                                </p>
                            </div>

                            {/* Contact Cards */}
                            <div className="space-y-4 w-full max-w-md">
                                {/* WhatsApp Us */}
                                <a
                                    href={`https://wa.me/${contactInfo.phone.replace(/[^0-9]/g, '')}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-4 bg-white rounded-xl p-4 shadow-sm border border-gray-100 text-left hover:border-orange-200 transition-colors"
                                >
                                    <div className="w-12 h-12 bg-orange-50 rounded-xl flex items-center justify-center flex-shrink-0">
                                        <div className="text-orange-500">
                                            <WhatsAppIcon />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 text-sm">WhatsApp Us</p>
                                        <p className="font-semibold text-gray-900">{contactInfo.phone}</p>
                                    </div>
                                </a>

                                {/* Email */}
                                <div className="flex items-center gap-4 bg-white rounded-xl p-4 shadow-sm border border-gray-100 text-left">
                                    <div className="w-12 h-12 bg-orange-50 rounded-xl flex items-center justify-center flex-shrink-0">
                                        <div className="text-orange-500">
                                            <MailIcon />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 text-sm">Email</p>
                                        <p className="font-semibold text-gray-900">{contactInfo.email}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Social Links */}
                            <div>
                                <p className="text-gray-700 font-medium mb-3">Follow us:</p>
                                <div className="flex items-center justify-center gap-4">
                                    <a href="https://www.facebook.com/people/BentoBox/61579713676790/" className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-orange-500 hover:bg-orange-50 transition-colors shadow-sm border border-gray-100">
                                        <FacebookIcon />
                                    </a>
                                    <a href="https://x.com/getbentobox_?s=21" className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-orange-500 hover:bg-orange-50 transition-colors shadow-sm border border-gray-100">
                                        <TwitterIcon />
                                    </a>
                                    <a href="https://www.linkedin.com/company/getbentobox/" className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-orange-500 hover:bg-orange-50 transition-colors shadow-sm border border-gray-100">
                                        <LinkedInIcon />
                                    </a>
                                    <a href="https://www.instagram.com/getbentobox.in" className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-orange-500 hover:bg-orange-50 transition-colors shadow-sm border border-gray-100">
                                        <InstagramIcon />
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Email Button */}
                        <div className="w-full lg:w-1/2 flex items-center justify-center">
                            <div className="text-center">
                                <a
                                    href={`mailto:${contactInfo.email}?subject=Query from BentoBox Website`}
                                    className="inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold py-4 px-10 rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-orange-200 text-lg group"
                                >
                                    <MailIcon />
                                    <span>Email us your query</span>
                                    <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </a>
                                <p className="text-gray-500 text-sm mt-4">
                                    We respond within 24 hours during service hours*
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactUs;
